'use client';

import { ICasesComponent } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './RelatedCases.module.scss';
import CaseCard from '../../CaseCard';
import Button, { ButtonVariants } from '../../../../components/Button';

const RelatedCases = ({ data }: { data: ICasesComponent }) => (
  <section className={classNames(styles.relatedCases, 'container')}>
    <div className={styles.relatedCasesHead}>
      <h2 className={styles.relatedCasesTitle}>{data.title}</h2>
      <Button
        variant={ButtonVariants.TRANSPARENT}
        icon={(
          <svg className={styles.viewAllIcon}>
            <use
              xlinkHref='/media/arrow-right-bold.svg#arrowRight'
              href='/media/arrow-right-bold.svg#arrowRight'
            />
          </svg>
        )}
        iconSize={{ width: 24, height: 24 }}
        className={styles.viewAllButton}
        link='/cases'
      >
        View all
      </Button>
    </div>
    <div className={styles.cases}>
      {data.cases.map((caseItem) => (
        <CaseCard
          key={caseItem.id}
          data={caseItem}
          relatedView
        />
      ))}
    </div>
  </section>
);

export default RelatedCases;
